/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var REPORT_STATUS;
(function (REPORT_STATUS) {
    REPORT_STATUS["PENDING"] = "pending";
    REPORT_STATUS["WEBHOOK_RECEIVED"] = "webhook_received";
    REPORT_STATUS["EXPIRED"] = "expired";
    REPORT_STATUS["COMPLETED"] = "completed";
    REPORT_STATUS["NOT_FOUND"] = "not_found";
    REPORT_STATUS["UNABLE_TO_CONNECT"] = "unable_to_connect";
    REPORT_STATUS["EMPTY"] = "empty";
})(REPORT_STATUS || (REPORT_STATUS = {}));
